// jQuery shim for esbuild
// WordPress loads jQuery globally, so we just export the global jQuery
export const $ = window.jQuery || window.$;
export default $;
